<template>
  <Loader v-show="globalLoading" :global-loading="globalLoading" />
  <div v-show="!globalLoading">
    <Order v-if="orderOpen" :tariff="showCaseTariff" :close-order-modal="closeOrderModal" />
    <div v-else>
      <Navbar @user-authorization-status="handleUserAuthorizationStatus" />
      <Transition>
        <OrderForm v-if="isOrderFormOpen.header" :id="getOrderBlockId()" :close="orderFormClose" :plans="getPlans()" />
      </Transition>
      <Introduction :lang="lang" :open="orderFormOpen" />
      <Transition>
        <OrderForm v-if="isOrderFormOpen.introduction" :id="getOrderBlockId()" :close="orderFormClose" :plans="getPlans()" />
      </Transition>
      <Showcase :lang="lang" :open-order-modal="openOrderModal" :open-pre-order-form="preOrderFormOpen" />
      <ToolChoose :lang="lang" :open="orderFormOpen" class="--top-offset" />
      <Transition>
        <OrderForm v-if="isOrderFormOpen.toolchoose" :id="getOrderBlockId()" :close="orderFormClose" :plans="getPlans()" />
      </Transition>
      <Result subtitle="Examples of visualization produced by AI Getfloorplan" title="What will you get?" />
      <Gallery :lang="lang" :open-question-form="questionFormOpen" />
      <Automation :visible="loading.automation" ref="automation" :open-question-form="questionFormOpen" class="--main-page" hide-action-btn />
      <InteriorStyle :visible="loading.widget" ref="widget" />
      <CustomStyle :lang="lang" :open-question-form="questionFormOpen" />
      <Trust :visible="loading.trust" ref="trust" :open="orderFormOpen" class="--main-page" lang="en" hide-action-btn />
      <Transition>
        <OrderForm v-if="isOrderFormOpen.trust" :id="getOrderBlockId()" :close="orderFormClose" :plans="getPlans()" />
      </Transition>
      <Guarantee class="--top-offset" />
      <Feedback :visible="loading.feedback" ref="feedback" />
      <News :items="news" :title="title" page="--main" />
      <Powered :visible="loading.powered" ref="powered" />
      <Faq :open-question-form="questionFormOpen" class="--internal" />
      <FooterBlock />
      <ScrollToTop />
      <Transition>
        <QuestionFormModal :form-source="formSource" v-if="isQuestionFormOpen" :close="questionFormClose" :open-message="questionSuccessOpen" />
      </Transition>
      <Transition>
        <QuestionFormModal v-if="isPreOrderFormOpen" :close="preOrderFormClose" :open-message="questionSuccessOpen" title="Submit a pre-order request" is-showcase-pre-order-form />
      </Transition>
      <Transition>
        <QuestionSuccessModal v-if="isQuestionSuccessOpen" :close="questionSuccessClose" />
      </Transition>
      <Transition>
        <CookieAcceptPopup v-if="!isCookieAccept" :close="cookieAccept" />
      </Transition>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import Navbar from '@/Components/En/Common/Navbar.vue';
import Introduction from '@/Components/En/MainPage/Introduction.vue';
import OrderForm from '@/Components/En/Order/OrderForm.vue';
import Showcase from '@/Components/En/MainPage/Showcase.vue';
import ToolChoose from '@/Components/En/MainPage/ToolChoose.vue';
import InteriorStyle from '@/Components/En/Common/InteriorStyle.vue';
import Automation from '@/Components/En/Common/Automation.vue';
import Guarantee from '@/Components/En/MainPage/Guarantee.vue';
import Powered from '@/Components/En/MainPage/Powered.vue';
import Trust from '@/Components/En/Common/Trust.vue';
import Feedback from '@/Components/En/MainPage/Feedback.vue';
import Faq from '@/Components/En/Common/Faq.vue';
import News from '@/Components/En/News/index.vue';
import FooterBlock from '@/Components/En/Common/Footer.vue';
import QuestionFormModal from '@/Components/En/Modals/QuestionFormModal.vue';
import QuestionSuccessModal from '@/Components/En/Modals/QuestionSuccessModal.vue';
import CookieAcceptPopup from '@/Components/En/Common/CookieAcceptPopup.vue';
import ScrollToTop from '@/Components/En/Common/ScrollToTop.vue';
import Result from '@/Components/En/MainPage/Result.vue';
import Order from '@/Components/En/Order/index.vue';
import Loader from '@/Components/En/Common/Loader.vue';
import Gallery from '@/Components/En/Common/Gallery.vue';
import CustomStyle from '@/Components/En/Common/CustomStyle.vue';
import { allNews } from '@/enums/news';
import { changeMetaKeywords } from '@/helpers';
import { keywords } from '@/enums/keywords';

export default {
  name: 'Landing',
  components: {
    Navbar,
    Introduction,
    OrderForm,
    Showcase,
    ToolChoose,
    InteriorStyle,
    Automation,
    Guarantee,
    Powered,
    Trust,
    Feedback,
    Gallery,
    Faq,
    News,
    FooterBlock,
    QuestionFormModal,
    QuestionSuccessModal,
    CookieAcceptPopup,
    ScrollToTop,
    Result,
    Order,
    Loader,
    CustomStyle,
  },
  data() {
    return {
      isOrderFormOpen: {
        header: false,
        introduction: false,
        toolchoose: false,
        trust: false,
      },
      lang: 'en',
      loading: {},
      plans: {},
      showCaseTariff: null,
      isQuestionFormOpen: false,
      isPreOrderFormOpen: false,
      isQuestionSuccessOpen: false,
      isCookieAccept: Boolean(localStorage.getItem('show')),
      news: [allNews[0], allNews[1], allNews[2]],
      title: 'News and information',
      orderOpen: false,
      globalLoading: true,
    };
  },
  mounted() {
    changeMetaKeywords(keywords.main);

    window.addEventListener('scroll', () => {
      Object.keys(this.$refs).forEach((el) => {
        const posTop = this.$refs[el]?.$el?.getBoundingClientRect().top;
        if (posTop && posTop < window.innerHeight) {
          this.loading[el] = true;
        }
      });
    });

    if (window.location.hash) {
      setTimeout(() => VueScrollTo.scrollTo(`#${window.location.hash.slice(1)}`, 450, { easing: 'linear' }), 350);

      if (window.location.hash === '#gallerySection') {
        this.questionFormOpen('demo');
      }
    }
  },
  methods: {
    handleUserAuthorizationStatus({ authorized }) {
      if (authorized) {
        this.globalLoading = false;
      } else {
        this.globalLoading = false;
      }
    },
    orderFormOpen(block, plans) {
      this.orderFormClose();
      this.plans = plans;
      this.isOrderFormOpen[block] = true;
    },
    orderFormClose() {
      Object.keys(this.isOrderFormOpen).forEach((key) => {
        this.isOrderFormOpen[key] = false;
      });
    },
    getPlans() {
      return Object.keys(this.plans).map((key) => this.plans[key]);
    },
    questionFormOpen(source = 'default') {
      this.formSource = source;
      this.isQuestionFormOpen = true;
    },
    questionFormClose() {
      this.isQuestionFormOpen = false;
    },
    preOrderFormOpen() {
      this.isPreOrderFormOpen = true;
    },
    preOrderFormClose() {
      this.isPreOrderFormOpen = false;
    },
    questionSuccessOpen() {
      this.isQuestionSuccessOpen = true;
    },
    questionSuccessClose() {
      this.isQuestionSuccessOpen = false;
    },
    cookieAccept() {
      this.isCookieAccept = true;
    },
    getOrderBlockId() {
      return `${Object.keys(this.isOrderFormOpen).find((key) => this.isOrderFormOpen[key] === true)}-order-form`;
    },
    openOrderModal(tariff) {
      this.orderOpen = true;
      this.showCaseTariff = tariff;
    },
    closeOrderModal() {
      this.orderOpen = false;
      this.showCaseTariff = null;
    },
    setLoadingComplete() {
      this.globalLoading = false;
    },
  },
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
